import { Injectable } from '@angular/core';
import { ExcelReaderService } from './excel-reader.service';
import { PrizesService } from '../services/prizes.service';
import { StateService } from '../services/state.service';

@Injectable({
  providedIn: 'root'
})
export class PrizesLoaderService {

  constructor(
    private excelReader: ExcelReaderService,
    private prizesService: PrizesService,
    private stateService: StateService
  ) { }

  public async executePrizesReplacement(excelFile: any) : Promise<boolean>{
    try {
      const prizesData = await this.excelReader.parseExcelFile(excelFile);
      const prizesArr = await this.createPrizesArray(prizesData);
      if (prizesArr.length > 0) {
        if(this.stateService.getState() == 'state-pumps'){
          await this.prizesService.clearPumpsPrizesData();
          await this.prizesService.setPumpsPrizes(prizesArr);
        } else if(this.stateService.getState() == 'state-airconditioners'){ 
          await this.prizesService.clearAirconditionersPrizesData();
          await this.prizesService.setAirconditionersPrizes(prizesArr);
        }
        return true;
      } else if (prizesArr.length == 0){
        if(this.stateService.getState() == 'state-pumps'){
          await this.prizesService.clearPumpsPrizesData();
        } else if(this.stateService.getState() == 'state-airconditioners'){ 
          await this.prizesService.clearAirconditionersPrizesData();
        }
        return true;
      }
      else {
        return false;
      }
    } catch (e) {
      console.error(e);
      console.error('Could not update winners status');
      return false;
    }
  }

  private async createPrizesArray(data:any): Promise<any>{
    let prizesArr:Array<any> = []
    data.forEach((prize:any) => prizesArr.push({
      place: prize.place,
      prizeAmount: prize.prizeAmount
    }));
    return prizesArr;
  }
}
